import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { unitSellBysQueryLinkerSchema } from './unit-sell-bys-query-linker-schema';

export const unitSellBysQuerySchema = z.object({
  ...unitSellBysQueryLinkerSchema.shape,
  status: statusQuerySchema,
  products_count: z.number(),
});

export type UnitSellBysQuerySchema = z.infer<typeof unitSellBysQuerySchema>;

export const unitSellBysQueryAllSchema = paginatedResponseSchema(unitSellBysQuerySchema);
export type UnitSellBysQueryAllSchema = z.infer<typeof unitSellBysQueryAllSchema>;
